<template>
  <div>

    <div class="Grid_Container">
      <div class="Grid_Year">
        <transition name="anim2" mode="out-in">
          <ul :key="toAnimate">
            <li v-if="toAnimate">Active Year(s)</li>
            <li v-if="toAnimate"></li>
            <li v-for="object in info" :key="object.ID">
              {{object.Year}}
              <br />
            </li>
          </ul>
        </transition>
      </div>

      <div class="Grid_Slash">
        <transition name="anim4" mode="out-in">
          <ul :key="toAnimate">
            <li v-if="toAnimate">||</li>
            <li v-if="toAnimate" ></li>
            <li v-for="object in info" :key="object.ID">
              ||
              <br />
            </li>
          </ul>
        </transition>
      </div>

      <div class="Grid_Name">
        <transition name="anim3" mode="out-in">
          <ul :key="toAnimate">
            <li v-if="toAnimate">Click To Learn More</li>
            <li v-if="toAnimate"></li>
            <li v-for="object in info" v-bind:key="object.ID">
              <router-link :to="`/${ path }/${object.ID}`">
                <button @click="setPath(object.Name)">{{object.Name}}</button>
              </router-link>
            </li>
          </ul>
        </transition>
      </div>
    </div>


    <!-- <p>{{ info }}</p> -->
  </div>
</template>

<script>
import axios from "axios";
import {store} from "../store.js";

export default {
  data() {
    return {
      info: null,
      path: null,
      toAnimate:null
    };
  },
  methods: {
    getPath: function() {
      this.path = this.$router.currentRoute.path.split("/")[1];
    },
    allInfo: function() {
      axios
        .get(store.getphpPath() + "DBtry.php", {
          params: {
            type: "all",
            table: this.$router.currentRoute.path.split("/")[1],
            rowID: "*"
          }
        })
        .then(response => {
          this.info = response.data;
          this.toAnimate = response.data[0].ID;
        })
        .catch(error => {
          console.log("OOOOPS");
          console.log(error);
        });
    },
    setPath(PathName){
      store.setSubPath(PathName.toUpperCase());
    }
  },
  created() {
    this.getPath();
    this.allInfo();
    store.clearSubPath();
  },
  watch: {
    $route(to, from) {
      // this.show = false;
      this.getPath();
      this.allInfo();
      store.clearSubPath();
      // this.startAnim();
      // this.show = !this.show;
    }
  },
  beforeRouteUpdate (to, from, next) {
        this.toAnimate=null;
        next();
  }
  ,
  beforeRouteLeave(to, from, next){
      this.info=null,
      this.toAnimate=null;
      setTimeout(() => { next() }, 1000)
  }

};
</script>

<style>

ul {
  padding: 0;
  margin: none;
}

.Grid_Year {
  font-family: "Helvetica";
  text-align: right;
  -ms-grid-column: 1;
  grid-column: 1;
  overflow: hidden;
}

.Grid_Slash {
  font-family: "Helvetica";
  text-align: center;
  -ms-grid-column: 2;
  grid-column: 2;
  overflow: hidden;
}

.Grid_Name {
  font-family: "Helvetica";
  -ms-grid-column: 3;
  grid-column: 3;
  overflow: hidden;
}

.Grid_Name button{
  -o-text-overflow: ellipsis;
     text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  padding: 0px 5px;
  height: 20px;
  max-height: 20px;
  font-family: "Helvetica";
}

.Grid_Year li{
  font-family: "Courier";
  font-size:16px;
  padding: 0px 5px;
  height: 20px;
  max-height: 20px;
}

.Grid_Slash li{
  width: 100%;
  height: 20px;
  padding:0px;
  max-height: 20px;
}

.Grid_Name li{
  font-family: "Courier";
  font-size: 16px;
  height: 20px; 
  max-height: 20px;
}

.Grid_Container {
  margin-top:2em;
  display: -ms-grid;
  display: grid;
  grid-gap: 0.5em;
  -ms-grid-columns: 1fr 0.5em 0.03fr 0.5em 1fr;
  grid-template-columns: 1fr 0.03fr 1fr;
}

/* Years */

.anim2-leave-active {
  -webkit-transition: all 0.85s ease;
  -o-transition: all 0.85s ease;
  transition: all 0.85s ease;
}
.anim2-enter,
.anim2-leave-to {
  opacity: 0;
  -webkit-transform: translateX(375px);
      -ms-transform: translateX(375px);
          transform: translateX(375px);
}

.anim2-enter-active, .anim3-enter-active{
  -webkit-transition: all 0.85s ease;
  -o-transition: all 0.85s ease;
  transition: all 0.85s ease;
  -webkit-transition-delay:0.3s;
       -o-transition-delay:0.3s;
          transition-delay:0.3s;
}

/* Buttons */

.anim3-leave-active {
  -webkit-transition: all 0.85s ease;
  -o-transition: all 0.85s ease;
  transition: all 0.85s ease;
}
.anim3-enter,
.anim3-leave-to {
  opacity: 0;
  -webkit-transform: translateX(-375px);
      -ms-transform: translateX(-375px);
          transform: translateX(-375px);
}

/* Slashs */

.anim4-enter-active {
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.anim4-leave-active {
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  -webkit-transition-delay: 0.5s;
       -o-transition-delay: 0.5s;
          transition-delay: 0.5s;
}
.anim4-enter {
  opacity: 0;
  -webkit-transform: translateY(-200px);
      -ms-transform: translateY(-200px);
          transform: translateY(-200px);
}

.anim4-leave-to {
  opacity: 0;
  -webkit-transform: translateY(200px);
      -ms-transform: translateY(200px);
          transform: translateY(200px);
}

</style>
